import { SavePartyMutation37kzgcr2r74ko as SavePartyMutation } from './schema/SavePartyMutation.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Accepted_instancehwhu2w41uegl as Accepted_instance } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/CommandResult.mjs';
import { Dispatcher396y2mcz9r128 as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/SavePartyCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_instance19mvqqhuhhta7 as Companion_instance } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { Companion_instance36a6zttu8bqia as Companion_instance_0 } from '../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/party/PairingRule.mjs';
import { SavePartyInput3ikp23en56cie as SavePartyInput } from './schema/type/SavePartyInput.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *perform(command, $completion) {
  yield* this.w6q(new (SavePartyMutation())(savePartyInput(command.c2l_1)), $completion);
  return Accepted_instance;
}
var SdkSavePartyCommandDispatcherClass;
function SdkSavePartyCommandDispatcher() {
  if (SdkSavePartyCommandDispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkSavePartyCommandDispatcher', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkSavePartyCommandDispatcherClass = $;
  }
  return SdkSavePartyCommandDispatcherClass;
}
function savePartyInput(_this__u8e3s4) {
  return new (SavePartyInput())(_this__u8e3s4.u2c_1, Companion_instance.j47(_this__u8e3s4.a2d_1), Companion_instance.j47(_this__u8e3s4.z2c_1), Companion_instance.j47(Companion_instance_0.t2c(_this__u8e3s4.v2c_1)), Companion_instance.j47(_this__u8e3s4.w2c_1), Companion_instance.j47(_this__u8e3s4.x2c_1), Companion_instance.j47(_this__u8e3s4.y2c_1), Companion_instance.j47(_this__u8e3s4.b2d_1), Companion_instance.j47(_this__u8e3s4.c2d_1), Companion_instance.j47(_this__u8e3s4.d2d_1));
}
//region block: exports
export {
  SdkSavePartyCommandDispatcher as SdkSavePartyCommandDispatcher1x5cidvmu3vb0,
  perform as perform7mh21y7i2qpg,
};
//endregion

//# sourceMappingURL=SdkSavePartyCommandDispatcher.mjs.map
